"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _LocaleContext = require("../locales/LocaleContext");
var _default2 = _interopRequireDefault(require("../locales/default"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledSpin = _interopRequireWildcard(require("./StyledSpin"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["prefixCls", "children", "text", "spinning", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Spin = /*#__PURE__*/function (_Component) {
  function Spin() {
    (0, _classCallCheck2.default)(this, Spin);
    return _callSuper(this, Spin, arguments);
  }
  (0, _inherits2.default)(Spin, _Component);
  return (0, _createClass2.default)(Spin, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        prefixCls = _this$props.prefixCls,
        children = _this$props.children,
        text = _this$props.text,
        spinning = _this$props.spinning,
        className = _this$props.className,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var classString = (0, _classnames.default)(prefixCls, className);
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleReceiver, {
          componentName: "Spin",
          defaultLocale: _default2.default.Spin
        }, function (localeCode, locale) {
          return /*#__PURE__*/_react.default.createElement(_StyledSpin.default, (0, _extends2.default)({
            theme: theme,
            spinning: spinning,
            $nested: !!children
          }, rest, {
            className: classString
          }), spinning && /*#__PURE__*/_react.default.createElement(_StyledSpin.StyledSpinWrap, {
            className: "".concat(prefixCls, "-wrapper")
          }, /*#__PURE__*/_react.default.createElement(_StyledSpin.StyledSpinDot, {
            className: "".concat(prefixCls, "-marker")
          }, /*#__PURE__*/_react.default.createElement(_StyledSpin.StyledSpinLoader, {
            viewBox: "25 25 50 50"
          }, /*#__PURE__*/_react.default.createElement(_StyledSpin.StyledSpinLoaderPath, {
            className: "loader-path",
            cx: "50",
            cy: "50",
            r: "20",
            fill: "none",
            strokeWidth: "4"
          }))), text !== '' && /*#__PURE__*/_react.default.createElement(_StyledSpin.StyledSpinText, {
            className: "".concat(prefixCls, "-content-text")
          }, text || locale.loadingText)), children && /*#__PURE__*/_react.default.createElement(_StyledSpin.StyledSpinContainer, {
            className: "".concat(prefixCls, "-box-container")
          }, children));
        });
      });
    }
  }]);
}(_react.Component);
Spin.propTypes = {
  prefixCls: _propTypes.default.string,
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  text: _propTypes.default.string,
  spinning: _propTypes.default.bool
};
Spin.defaultProps = {
  prefixCls: 'ykb-spinner',
  spinning: false,
  className: ''
};
var _default = exports.default = Spin;